import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Amicorp from "../../../Images/amicorp.svg";
import DH from "../../../Images/DH.svg";
import Delphi from "../../../Images/Delphi.svg";
import HCP from "../../../Images/HCP.png";
import DS from "../../../Images/DS.png";
import LTI from "../../../Images/LTI.jpg";
import Coginizant from "../../../Images/Cognizant.png";
import Fidelity from "../../../Images/Fidelity.svg";
import Nokia from "../../../Images/Nokia.svg";
import Prajavani from "../../../Images/Prajavani.png";
import SocGen from "../../../Images/SocGen.png";
import Subex from "../../../Images/Subex.png";
import ITCInfo from "../../../Images/ITCInfo.png";
import MyDealsCoupons from "../../../Images/MyDealsCoupons.jpg";
import GE from "../../../Images/GE.png";
import AXA from "../../../Images/AXA.png";
import VA from "../../../Images/VA.svg";
import PathiSilks from "../../../Images/PathiSilks.png";
import Gr from "../../../Images/gr-logo.png";
import Logica from "../../../Images/Logica_Plc.jpg";
import Mercer from "../../../Images/Mercer.png";


const Container = tw.div`relative md:my-16 w-full `;




const StyledHeading2 = styled.h2`
  ${tw`text-center text-xl md:text-3xl font-extrabold leading-8 px-2 pb-16`}
  color: #1a202c;
  text-transform: none;
`;

const MarqueeInner = styled.div`
  ${tw`flex gap-8 pr-4`}
  width: fit-content; /* Adjust to fit the content */
  height: 100%;
  animation: marquee var(--marquee-duration) linear infinite;
  animation-play-state: running; /* Ensure the animation is running by default */

  &:hover {
    animation-play-state: paused; /* Pause animation on hover */
  }

  @keyframes marquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

// Define the styled item container
const MarqueeItem = styled.div`
  ${tw`flex items-center justify-center bg-white`}
  flex: 0 0 auto; /* Prevent item from growing or shrinking */
border-radius:"10px";
box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 0.5px, 
            rgba(42, 51, 70, 0.03) 0px 1px 0.5px -0.25px, 
            rgba(42, 51, 70, 0.04) 0px 1.5px 1.5px -0.5px, 
            rgba(42, 51, 70, 0.04) 0px 2px 2px -0.75px, 
            rgba(42, 51, 70, 0.03) 0px 3px 3px -1.25px, 
            rgba(42, 51, 70, 0.03) 0px 6px 6px -3px, 
            rgba(42, 51, 70, 0.03) 0px 12px 12px -4px;
  width: 340px; /* Set a fixed width */
  height: 160px; /* Ensure item takes full height of container */

  img {
    width: 56vw; /* Consistent width */
    height: 16vh; /* Consistent height */
    object-fit: contain; /* Maintain aspect ratio */
   
  }

  @media (min-width: 1440px) {
    img {
      width: 11vw; /* Consistent width */
      height: 7vh; /* Consistent height */
      object-fit: contain; /* Maintain aspect ratio */
    }
  }
`;
const Scroller = () => {
  let images = [
    { id: "1", src: Amicorp,width:"100px",height:"50px" },
    { id: "2", src: DS,width:"100px",height:"50px" },
    { id: "3", src: DH,width:"100px",height:"50px" },
    { id: "4", src: Delphi ,width:"100px",height:"90px"},
    { id: "5", src: HCP,width:"70px",height:"60px" },
    { id: "6", src: Coginizant},
    { id: "7", src: LTI ,width:"110px",height:"50px"},
    { id: "8", src: Fidelity,width:"100px",height:"50px" },
    { id: "9", src: Nokia,width:"100px",height:"50px" },
    { id: "10", src: MyDealsCoupons ,width:"100px",height:"50px" },
    { id: "11", src: Prajavani ,width:"100px",height:"50px"},
    { id: "12", src: SocGen ,width:"100px",height:"50px"},
    { id: "13", src: Subex,width:"100px",height:"45px" },
    { id: "14", src: ITCInfo,width:"100px",height:"60px" },
    { id: "15", src: GE,width:"100px",height:"60px" },
    { id: "16", src: AXA,width:"90px",height:"60px"  },
    { id: "17", src: VA },
    { id: "18", src: PathiSilks },
    { id: "19", src: Gr },
    { id: "20", src: Logica,width:"100px",height:"50px" },
    { id: "21", src: Mercer,width:"100px",height:"50px" },
];
    // Duplicate the list of images for seamless scrolling
    const extendedImages = [...images, ...images];

  return (
    <Container
      style={{
        boxShadow:
          "0 3px 5px rgba(0, 0, 0, 0.05), 0 -3px 5px rgba(0, 0, 0, 0.05)",
      backgroundColor:"#f7f7f7",
      overflow:"hidden",
      }}
    >
      <div
        style={{
          // backgroundColor: "rgb(247 250 252)",
          borderTop: "rgb(202 199 199) 2px ",
          borderBottom: "rgb(202 199 199) 2px ",
          paddingTop: "50px",
          paddingBottom: "80px",
        }}
      >
     
        <StyledHeading2>
          Some amazing <span className="text-primary-500">partners </span> we
          have worked with
        </StyledHeading2>
   
       
            <MarqueeInner style={{ '--marquee-duration': '135000ms' }}>
                {extendedImages.map(item => (
                    <MarqueeItem key={item.id}>
                        <img     src={item.src} alt=""     style={{
                    backgroundColor: item.backgroundColor,
                widows:item.width,
                height:item.height
                  }} />
                    </MarqueeItem>
                ))}
            </MarqueeInner>
       
      </div>
    </Container>
  );
};

export default Scroller;
